@if (contract()) {
    <div class="contract-data-base br-4 p-16">
        <dl class="grid-container vertical-gutter-lg">
            <app-portal-widget-details
                class="g-12 xs:g-6"
                heading="Versicherung"
                [detail]="contract().insuranceType | insuranceType"
            ></app-portal-widget-details>
            <app-portal-widget-details
                class="g-12 xs:g-6"
                heading="Versicherungsnr."
                [detail]="contract().insuranceNumber"
            ></app-portal-widget-details>
            @if (contract().contractFrom) {
                <app-portal-widget-details
                    class="g-6"
                    heading="Vertragsbeginn"
                    [detail]="contract().contractFrom"
                ></app-portal-widget-details>
            }
            @if (contract().contractTo) {
                <app-portal-widget-details
                    class="g-6"
                    heading="Vetragsende:"
                    [detail]="contract().contractTo"
                ></app-portal-widget-details>
            }
        </dl>
        @if (hasContractStarted()) {
            <div class="grid-container -end m-32:t">
                <a
                    damageReportButton
                    [contract]="contract()"
                    class="button -blue g-12 md:g-6"
                    [routerLink]="['/', 'portal', 'meine-vertraege', this.contract().id, 'schaden-melden']"
                ></a>
            </div>
        }
    </div>
}
